export default "__VITE_ASSET__CDLPTHrO__"